export default "__VITE_ASSET__CL4o04tA__"